// extracted by mini-css-extract-plugin
export default {"cardGrid":"WhitepaperIndex-module__cardGrid--xCLfs","layoutGrid":"WhitepaperIndex-module__layoutGrid--DOKxI","filtersColumn":"WhitepaperIndex-module__filtersColumn--B11Nb"};